import React from 'react';
import {
  TextInput
} from 'react-native';

//import * as _cmODT from './_cmODT';
import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import { a } from './_cmABT';
import * as _cr from './_cr';
import { useAny } from './_csLcl';
import { useMdlSchz } from './_csMdlSch';
import { useMdlPcrz } from './_csMdlPcr';
import { useMdlDtmz } from './_csMdlDtm';
import * as _hm from './_hm';
import * as _ht from './_ht';

export type tIptCz = {
  abtz: _ht.dz,
  cz: {
    bEdit?: _ht.b,
    bScr: _ht.b, // secure
    bRqr: _ht.b, // require
    bDrt: _ht.b, // direct change 
    iptType: 't' | 'p' | 'd' | 's', // t: text, p: pcr, d: dtm, s: sch
    ls?: _ht.ls,
    dtmz?: {
      crt: _ht.s,
      stt?: _ht.s,
      end?: _ht.s,
      hdys?: _ht.ls, // holliday
      dmds?: _ht.ls, // dimmed
    },
    vle?: _ht.n | _ht.s,
    onChg?: (_vle: _ht.n | _ht.s | _ht.dz) => void,
    cvtPfx: (_s: _ht.s) => _ht.s,
    bfrFcsAsync: () => _ht.b,
  },
  iptStlz: {
    showz: _ht.dz,
    editz: _ht.dz,
  },
  iptPtyz: _ht.dz,
};

const $grtAbtz = (pz?: {
  type?: _ht.s,
}) => {
  switch (pz?.type) {
    default:
      return {
        iptStlz: {
          showz: a("bc/t br/1 bw/2 dh/4 dw/f p/1 sc/t tc/lt9 ts/m ioc/t"),
          editz: a("bc/lt3 br/1 bw/2 dh/4 dw/f p/1 sc/lt1 tc/lt9 ts/m ioc/lt3"),
        },
        iptPtyz: {}
      }
  }
};

export const N = React.memo((pz: tIptCz) => {

  const _sMdlPcrz = useMdlPcrz();
  const _sMdlSchz = useMdlSchz();
  const _sMdlDtmz = useMdlDtmz();
  const _sText = useAny('');
  const _sVle = useAny(null);

  React.useEffect(() => {
    if (pz.cz?.vle || pz.cz?.vle == '' || pz.cz?.vle == 0) {
      if (pz.cz.iptType == 't') {
        _sVle.set(pz.cz?.vle);
        _sText.set(pz.cz?.vle);
      }
      if (_hm.i(pz.cz.iptType, ['p', 's'])) {
        _sVle.set(pz.cz?.vle);
        const _dz = _hm.getDz(pz.cz?.ls ?? [], pz.cz?.vle, 'key') ?? ({} as _ht.dz);
//        _sText.set(_dz.pfx ?? '');
        _sText.set(_dz.text ?? '');
      }
      if (pz.cz.iptType == 'd') {
        _sVle.set(pz.cz?.vle);
        _sText.set(pz.cz?.vle);
      }
    }
    else { // 初期化に必要
      if (pz.cz.iptType == 't') {
        _sVle.set('');
        _sText.set('');
      }
      if (_hm.i(pz.cz.iptType, ['p', 's'])) {
        _sVle.set(-1);
        _sText.set('');
      }
      if (pz.cz.iptType == 'd') {
        _sVle.set('');
        _sText.set('');
      }
    }
  }, [
    pz.cz?.ls,
    pz.cz?.vle,
  ]);

  const _abtz = $grtAbtz(pz.abtz);

  const _onChg = async (_vle: _ht.n | _ht.s | _ht.dz) => {
    //await _cmODT.setAsync();
    if (pz.cz?.onChg) pz.cz?.onChg(_vle);
  };

  let _o = (
    _cr.c(TextInput, {
      editable: pz.cz?.bEdit != false ? true : false,
      disabledInputStyle: {
        opacity: 1,
        backgroundColor: 'transparent',
      },
      secureTextEntry: pz.cz?.bScr == true ? true : false,
      selectTextOnFocus: pz.cz?.bEdit != false ? true : false,
      autoComplete: 'off', // none: for web, off: for iphone / android
      style: {
        ... pz.cz?.bEdit == false ? _abtz.iptStlz?.showz : _abtz.iptStlz?.editz,
        ... pz.cz?.bEdit == false ? pz.iptStlz?.showz : pz.iptStlz?.editz,
      },
      value: 
        pz.cz?.bEdit == false && pz.cz.cvtPfx ?
          pz.cz.cvtPfx(_sVle.crt)
        : _sText.crt,
      onChangeText: (_s: _ht.s) => {
        if (pz.cz.iptType == 't') {
          _sText.set(_s);
          _sVle.set(_s);
          if (pz.cz.bDrt) _onChg(_s); // google password manager を反映する場合などに使用
        }
      },
      onBlur: () => {
        if (pz.cz.iptType == 't') {
          _onChg(_sVle.crt);
        }
      },
      onFocus: async () => {
        if (pz.cz?.bEdit == false) return; // 無反応
        if (pz.cz?.bfrFcsAsync) {
          const _b = await pz.cz?.bfrFcsAsync()
          if (!_b) return;
        }
        if (pz.cz.iptType == 'p') {
          _sMdlPcrz.show({
            ls: pz.cz.ls,
            onPrs: (_dz: _ht.dz) => {
//              _sText.set(_dz.pfx);
              _sText.set(_dz.text);
              _sVle.set(_dz.key);
              _onChg(_dz);
            },
          });
        } 
        if (pz.cz.iptType == 's') {
          _sMdlSchz.show({
            ls: pz.cz?.ls,
            onPrs: (_dz: _ht.dz) => {
//              _sText.set(_dz.pfx);
              _sText.set(_dz.text);
              _sVle.set(_dz.key);
              _onChg(_dz);
            },
          });
        } 
        if (pz.cz.iptType == 'd') {
          _sMdlDtmz.show({
            dtmz: {
              ... pz.cz?.dtmz,
              crt: _hm.f(_sVle.crt) ? _sVle.crt : (pz.cz?.dtmz?.crt ?? ''),
            },
            onPrs: (_dtm: _ht.s) => {
              _sText.set(_dtm);
              _sVle.set(_dtm);
              _onChg(_dtm);
            },
          });
        } 
      },
      ... _abtz.iptPtyz,
      ... pz.iptPtyz,
    })
  );

  if (_hm.i(pz.cz.iptType, ['p', 's', 'd'])) {
    _o = (
      _cr.c(BoxC.N, {
        boxStlz: a(`dw/f`),
        boxClds: [
          _o,
          pz.cz.bEdit ?
          _cr.c(BtnC.N, {
            key: -20,
            bfrIconCz: {
              iconPtyz: a(`icc/lt3 icn/remove ics/1`),
            },
            frmCz: {
              boxStlz: a(`dp/a db/1.1 dr/0.25 dz/mainBdy+1 dw/2 dh/2 fd/ccc`),
              pslPtyz: {
                onPrs: () => {
                  /*
                  if (pz.cz.iptType == 't') {
                    _sText.set('');
                    _sVle.set('');
                    _onChg('');
                  } 
                  */
                  if (pz.cz.iptType == 'p') {
                    _sText.set(' ');
                    _sVle.set(-1);
                    _onChg(-1);
                  } 
                  if (pz.cz.iptType == 's') {
                    _sText.set(' ');
                    _sVle.set(-1);
                    _onChg(-1);
                  } 
                  if (pz.cz.iptType == 'd') {
                    _sText.set('');
                    _sVle.set('');
                    _onChg('');
                  } 
                }
              }
            },
          })
          : undefined,
        ]
      })
    );
  }

  return _o;
});

export const Rqr = React.memo((pz: {
  sPz: _ht.dz
}) => {

  if (!_hm.i(pz.sPz.crt.phs, ['c', 'u'])) return null

  return (
    _cr.c(TextC.N, {
      pslStlz: a(`dw/f`),
      boxStlz: a(`dw/f fd/rec pr/1`),
      text: '※：必須',
      textStlz: a(`tb tc/rd5 ts/s`),
    })
  );
});